// Every report-param key the picture select block can persist, each set to null.

import { calcQuestionClearParams } from '@aytm/app/stats/page/question-views/components/lib/clear-params'

const QUESTION_PARAMS = ['tcv', 'cm', 'z', 's', 'cb', 'wc']
const SUB_ITEM_PARAMS = ['cm', 'z', 's', 'wc']

export const calcClearParams = ({ questionKey, answerVariants, batches, clusters } = {}) =>
  calcQuestionClearParams({
    questionKey,
    answerVariants,
    batches,
    clusters,
    question: QUESTION_PARAMS,
    subItem: SUB_ITEM_PARAMS
  })
